/*
 * PlayBear first-party acquisition context patch.
 *
 * Theme-side responsibility: with analytics consent, retain a minimal
 * first-touch context and publish ONE Shopify Customer Event. This file never
 * calls gtag(), dataLayer, fetch(), or a third-party analytics SDK. A single,
 * audited Custom Pixel is responsible for any downstream GA4 forwarding.
 */
(function () {
  'use strict';

  if (window.__pbAcquisitionContextInstalled) return;
  window.__pbAcquisitionContextInstalled = true;

  var cookieName = 'pb_acq_v1';
  var maxAgeSeconds = 60 * 60 * 24 * 30;
  var publishedOnThisPage = false;

  function text(value) {
    if (value === undefined || value === null) return '';
    return String(value).trim().slice(0, 100);
  }

  function analyticsAllowed() {
    try {
      if (window.Shopify && window.Shopify.customerPrivacy &&
          typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function') {
        return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true;
      }
      if (window.Shopify && window.Shopify.customerPrivacy &&
          typeof window.Shopify.customerPrivacy.currentVisitorConsent === 'function') {
        return window.Shopify.customerPrivacy.currentVisitorConsent().analytics === 'yes';
      }
    } catch (_error) {
      // A missing or unavailable consent API means do not track.
    }
    return false;
  }

  function readCookie() {
    var prefix = cookieName + '=';
    var items = document.cookie ? document.cookie.split(';') : [];
    for (var i = 0; i < items.length; i += 1) {
      var item = items[i].trim();
      if (item.indexOf(prefix) !== 0) continue;
      try {
        return JSON.parse(decodeURIComponent(item.slice(prefix.length)));
      } catch (_error) {
        return null;
      }
    }
    return null;
  }

  function writeCookie(context) {
    var secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = cookieName + '=' + encodeURIComponent(JSON.stringify(context)) +
      '; Max-Age=' + maxAgeSeconds + '; Path=/; SameSite=Lax' + secure;
  }

  function referrerHost() {
    if (!document.referrer) return '';
    try {
      return text(new URL(document.referrer).hostname.toLowerCase());
    } catch (_error) {
      return '';
    }
  }

  function currentContext() {
    var params = new URLSearchParams(window.location.search || '');
    return {
      version: '1',
      captured_at: new Date().toISOString(),
      first_landing_path: text(window.location.pathname),
      referral_code: text(params.get('ref')),
      sub_id: text(params.get('sub_id')),
      link_id: text(params.get('pb_link_id')) || text(params.get('link_id')),
      utm_source: text(params.get('utm_source')),
      utm_medium: text(params.get('utm_medium')),
      utm_campaign: text(params.get('utm_campaign')),
      utm_content: text(params.get('utm_content')),
      referrer_host: referrerHost()
    };
  }

  function hasAttributionSignal(context) {
    return Boolean(
      context.referral_code || context.sub_id || context.link_id ||
      context.utm_source || context.utm_medium || context.utm_campaign ||
      context.utm_content || context.referrer_host
    );
  }

  function publish(context, isNew) {
    if (publishedOnThisPage) return;
    if (!window.Shopify || !window.Shopify.analytics ||
        typeof window.Shopify.analytics.publish !== 'function') return;
    try {
      window.Shopify.analytics.publish('pb_acquisition_context', {
        pb_acquisition_version: context.version,
        pb_acquisition_new: isNew ? 'true' : 'false',
        pb_first_landing_path: context.first_landing_path,
        pb_referral_code: context.referral_code,
        pb_sub_id: context.sub_id,
        pb_link_id: context.link_id,
        pb_utm_source: context.utm_source,
        pb_utm_medium: context.utm_medium,
        pb_utm_campaign: context.utm_campaign,
        pb_utm_content: context.utm_content,
        pb_referrer_host: context.referrer_host
      });
      publishedOnThisPage = true;
    } catch (_error) {
      // Analytics must never alter customer-facing behaviour.
    }
  }

  function initialize() {
    if (!analyticsAllowed()) return;
    var existing = readCookie();
    var incoming = currentContext();
    var context = existing;
    var isNew = false;

    // Preserve the first meaningful acquisition context. Later direct visits
    // must not erase a creator code or campaign identifier.
    if (!existing && hasAttributionSignal(incoming)) {
      context = incoming;
      writeCookie(context);
      isNew = true;
    }
    if (context) publish(context, isNew);
  }

  function waitForConsentApi() {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      initialize();
      return;
    }
    window.Shopify.loadFeatures([
      { name: 'consent-tracking-api', version: '0.1' }
    ], function () {
      initialize();
    });
  }

  document.addEventListener('visitorConsentCollected', initialize);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForConsentApi, { once: true });
  } else {
    waitForConsentApi();
  }
})();
